import * as Yup from "yup";

const validationSchema = (schema: any) => {
  const valid = Yup.object({
    longitude: Yup.number()
      .typeError(schema.isNumber)
      .required(schema.isRequired),
    latitude: Yup.number()
      .typeError(schema.isNumber)
      .required(schema.isRequired),
  });
  return valid;
};

export default validationSchema;
